import { render } from "./Login.vue?vue&type=template&id=1e87e8a2"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"
script.render = render

export default script